import {
	FlexGap,
	ItemRow,
	ItemRowCell,
	ItemRowSize,
	StackVertical,
	useTranslation,
} from '@ukpostbox/frontend-framework';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFolder } from '@fortawesome/pro-solid-svg-icons/faFolder';
import { CustomFolderDragOver, CustomFolderEnter, CustomFolderLeave } from '../SharedFunctions/CustomFolders';
import { CustomFolderEntryType } from './FolderEntriesTypes';

function CustomFolderEntry(props: CustomFolderEntryType) {
	const { t } = useTranslation();
	const currentFolder = props.parentFolder ? props.parentFolder : props.folder;

	return (
		<ItemRow
			key={`customFolderRow${props.folder.id}`}
			title={`Custom Folder ${props.folder.description}`}
			extraClass={`custom-folder-list-entry ${props.gridView ? 'mailbox-item-block custom-folder-block' : 'custom-folder-item'}`}
			actionLink={{
				url: `../mail/custom-folder/${currentFolder.id}`,
			}}
			size={ItemRowSize.Large}
			extraProps={{
				'data-folder-id': currentFolder.id,
				draggable: false,
				onDragEnd: (e: any) => props.handleFolderMoveCallback(e),
				onDragEnter: (e: any) => CustomFolderEnter(e),
				onDragLeave: (e: any) => CustomFolderLeave(e),
				onDragOver: (e: any) => CustomFolderDragOver(e),
			}}
		>
			<ItemRowCell extraClass={`custom-folder-icon ${currentFolder.colour}-outline`}>
				<FontAwesomeIcon icon={faFolder} size={props.gridView ? '5x' : '2x'} />
			</ItemRowCell>
			<ItemRowCell>
				<StackVertical gap={FlexGap.ExtraSmall} extraClass='custom-folder-meta'>
					<span className='custom-folder-item-title'>{currentFolder.description}</span>
					{props.parentFolder ? 'Parent Folder' : 'Child Folder'} -{' '}
					{t('counts.item', { count: currentFolder.count })}
				</StackVertical>
			</ItemRowCell>
		</ItemRow>
	);
}

export { CustomFolderEntry };
